import { Text } from '@rsos/base-components';
import {
  OriginSourcePill,
  OriginSourceTitleRow,
} from '../etl/OriginSource.styles';

/** Page header summary with optional ingestion source pill next to the title. */
interface AirAmbulanceSourceInfoProps {
  title?: string | null;
  details?: string | null;
  sourceLabel?: string | null;
  requestedAt?: string | null;
}

function AirAmbulanceSourceInfo({
  title = null,
  details = null,
  sourceLabel = null,
  requestedAt = null,
}: AirAmbulanceSourceInfoProps): JSX.Element {
  return (
    <>
      {title && (
        <OriginSourceTitleRow data-name="air-ambulance-source-info-title-row">
          <Text color="primaryText" size="large" fontWeight="bold">
            {title}
          </Text>
          {sourceLabel != null && (
            <OriginSourcePill data-testid="air-ambulance-origin">
              {sourceLabel}
            </OriginSourcePill>
          )}
        </OriginSourceTitleRow>
      )}
      {requestedAt && (
        <Text
          mt={1}
          size="small"
          color="secondaryText"
          data-testid="air-ambulance-requested-at"
        >
          Requested at: {requestedAt}
        </Text>
      )}
      {details && (
        <Text mt={1} size="small" color="secondaryText">
          {details}
        </Text>
      )}
    </>
  );
}

export default AirAmbulanceSourceInfo;
